'use client';

import Skeleton from '@susu/custom-made/components/skeleton/skeleton';
import type { ProductType } from '@susu/custom-made/utils/productDefinition';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

function SkeletonWithProduct({ cdnDomain }: Readonly<{ cdnDomain: string }>) {
  const searchParams = useSearchParams();
  const product = searchParams.get('product') as ProductType | null;
  return <Skeleton product={product ?? undefined} cdnDomain={cdnDomain} />;
}

export default function LoadingSkeleton({ cdnDomain }: Readonly<{ cdnDomain: string }>) {
  return (
    <Suspense fallback={<Skeleton cdnDomain={cdnDomain} />}>
      <SkeletonWithProduct cdnDomain={cdnDomain} />
    </Suspense>
  );
}
